import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAppContext } from '../../contexts/AppContext';
import CreateOrderForm from '../../pages/Customer/CreateOrderForm';
import api from '../../api/client';
import apiClient from '../../api/client'; // Добавьте для запросов заказов
import './Footer.css';

import separator from '../../assets/Main/blue_separator.svg';
import separator_mob from '../../assets/Main/separator_mob.svg';
import logo from '../../assets/Main/logo_footer.svg';
import icon_location from '../../assets/Main/icon_location.svg';
import icon_vk from '../../assets/Main/icon_vk_blue.svg';
import icon_inst from '../../assets/Main/icon_inst_blue.svg';
import icon_tg from '../../assets/Main/icon_tg_blue.svg';
import gear4 from '../../assets/Main/gear4.svg';
import close from '../../assets/Main/icon_close.svg';

function Footer({ className }) {
  const { selectedCity } = useAppContext();
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole'));
  const [showCreateForm, setShowCreateForm] = useState(false)    

  // Состояния для модалки политики конфиденциальности
  const [showPolicyModal, setShowPolicyModal] = useState(false)
  const [policyContent, setPolicyContent] = useState('')
  const [policyLoading, setPolicyLoading] = useState(false)
  const [policyError, setPolicyError] = useState(null)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Следим за изменениями userRole в localStorage
  useEffect(() => {
    const handleStorage = () => setUserRole(localStorage.getItem('userRole'));
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  // Функция загрузки политики конфиденциальности
  const loadPrivacyPolicy = async () => {
    setPolicyLoading(true)
    setPolicyError(null)
    setPolicyContent('')

    try {
      const res = await api.get('/legal/privacy-policy')
      if (res.data?.content) {
        setPolicyContent(res.data.content)
      } else {
        setPolicyError('Документ не содержит содержимого')
      }
    } catch (err) {
      console.error('Ошибка загрузки политики:', err)
      setPolicyError('Не удалось загрузить политику конфиденциальности')
    } finally {
      setPolicyLoading(false)
    }
  }

  // Обработчик клика по ссылке "Политика конфиденциальности"
  const handlePolicyClick = (e) => {
    e.preventDefault()
    setShowPolicyModal(true)
    if (!policyContent) loadPrivacyPolicy()
  }

  // Закрытие модалки
  const closePolicyModal = () => {
    setShowPolicyModal(false)
  }

  // Функция для заказчика - открыть чат с последним заказом
  const handleCustomerSupport = async () => {
    const isAuthenticated = !!localStorage.getItem('accessToken')
    const userRole = localStorage.getItem('userRole')
    
    if (!isAuthenticated) {
      navigate('/enter')
      return
    }
    
    if (userRole !== 'CUSTOMER') {
      alert('Только заказчики могут открыть чат с заказом')
      return
    }
    
    try {
      const response = await apiClient.get('/customers/me/orders')
      const orders = response.data || []
      
      if (orders.length === 0) {
        alert('У вас нет созданных заказов.\nСоздайте заказ, чтобы начать общение с исполнителями.')
        return
      }
      
      const lastOrder = orders.sort((a, b) => {
        const dateA = new Date(a.publishedAt || a.createdAt || 0)
        const dateB = new Date(b.publishedAt || b.createdAt || 0)
        return dateB - dateA
      })[0]
      
      navigate(`/customer_order_edit/${lastOrder.id}`, {
        state: {
          activeTab: 'chat',
          openSupport: true,
        }
      })
      
    } catch (err) {
      console.error('Ошибка при получении заказов:', err)
      alert('Не удалось загрузить заказы. Попробуйте позже.')
    }
  }

  // Функция для исполнителя - открыть общий чат
  const handleExecutorSupport = () => {
    const isAuthenticated = !!localStorage.getItem('accessToken')
    
    if (!isAuthenticated) {
      navigate('/enter')
      return
    }
    
    navigate('/chat')
  }

  // Основной обработчик для кнопки поддержки
  const handleSupportClick = () => {
    const isAuthenticated = !!localStorage.getItem('accessToken')
    const role = localStorage.getItem('userRole')
    
    if (!isAuthenticated) {
      navigate('/enter')
      return
    }
    
    if (role === 'CUSTOMER') {
      handleCustomerSupport()
    } else if (role === 'EXECUTOR') {
      handleExecutorSupport()
    } else {
      navigate('/enter')
    }
  }

  const cityName = selectedCity?.label?.split(',')[0]?.trim() ?? 'Москва';

  // Главная страница в зависимости от роли
  const getHomePath = () => {
    if (!userRole) return '/';
    if (userRole === 'CUSTOMER') return '/main_customer';
    if (userRole === 'EXECUTOR') return '/main_executor';
    return '/';
  };

  // Кнопка "Оставить заявку"
  const createOrderPath = userRole === 'CUSTOMER' ? '/customer_create_order' : '/enter';

  // Кнопка "Найти заказы"
  const findOrdersPath = userRole === 'EXECUTOR' ? '/executor_all_orders' : '/enter';

  return (
    <div className="footer-shell">
      <img
        src={isMobile ? separator_mob : separator}
        alt=""
        className="separator2"
        aria-hidden="true"
      />

      <div className={`footer ${className || ''}`}>
        <div className="black-block">
          {/* Логотип + город */}
          <div className="black-block__title">
            <img src={logo} alt="logo" width={206} />
            <p>
              <img src={icon_location} alt="icon of location" />
              {cityName}
            </p>
          </div>

          {/* Три колонки */}
          <div className="three-columns d-flex flex-row">
            {/* Первая колонка — Платформа */}
            <div className="first-column">
              <p style={{ color: '#ffffff' }}>Платформа</p>

              <Link to={getHomePath()}>Главная</Link>
              <Link to="/about">О платформе</Link>
              <Link to="/customer_all_specialists">Каталог исполнителей</Link>
              <Link to="/faq">Ответы на частые вопросы</Link>
              <Link to="/contacts">Контакты</Link>
              <button 
                className="policy-link-footer" 
                onClick={handlePolicyClick}
                style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, textAlign: 'left', fontWeight:'600'}}
              >
                Политика конфиденциальности
              </button>
            </div>

            {/* Вторая колонка — Заказчику / Исполнителю */}
            <div className="second-column">
              <div className="side customer">
                <p>Заказчику</p>
                <button className="btn-white" onClick={() => navigate(createOrderPath)}>
                  Оставить заявку
                </button>
              </div>

              <div className="side executor">
                <p style={!isMobile ? { marginTop: '70px' } : {}}>Исполнителю</p>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <button className="btn-white" onClick={() => navigate(findOrdersPath)}>
                    Найти заказы
                  </button>
                  <button className="btn-blue" onClick={() => navigate('/pricing_plans')}>
                    Тарифы
                  </button>
                </div>
              </div>
            </div>

            {/* Третья колонка — Поддержка и соцсети */}
            <div className="third-column">
              <p>Остались вопросы?</p>
              <button className="btn-support" onClick={handleSupportClick}>
                Написать в чат поддержки
              </button>

              <div className="group-buttons d-flex flex-row">
                <a
                  href="https://www.instagram.com/rulla.pro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-soc-network"
                  style={isMobile?{width:'47px', height:'47px'}:{}}
                >
                  <img src={icon_inst} alt="icon instagram" style={{margin: '6px'}}/>
                </a>

                <a
                  href="https://t.me/rullapro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-soc-network"
                  style={isMobile?{width:'47px', height:'47px'}:{}}
                >
                  <img src={icon_tg} alt="icon telegram" style={{margin: '6px'}}/>
                </a>
              </div>

              <img src={gear4} alt="gear wheel" className="img-gear" />
            </div>
          </div>
        </div>
      </div>

      {/* Модалка Политики конфиденциальности */}
      {showPolicyModal && (
        <div className="modal-overlay" onClick={closePolicyModal}>
          <div className="modal-window policy-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closePolicyModal}>
              <img src={close} alt="Закрыть"/>
            </button>

            {policyLoading ? (
              <div className="policy-loading">Загрузка...</div>
            ) : policyError ? (
              <div className="policy-error">{policyError}</div>
            ) : (
              <div
                className="policy-content"
                dangerouslySetInnerHTML={{ __html: policyContent }}
                style={isMobile?{paddingTop:'10px'}:{}}
              />
            )}

            <button className="modal-action-btn" onClick={closePolicyModal} style={{marginTop:'50px'}}>
              Закрыть
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Footer;
